// src/pages/Datenschutz.jsx
import React from 'react';
import '../styles/Datenschutz.css';

const Datenschutz = () => {
    return (
        <div className="datenschutz-container">
            <h1>Datenschutzerklärung</h1>

            <section className="datenschutz-section">
                <h2>Allgemeiner Hinweis und Pflichtinformationen</h2>
                <p><strong>Benennung der verantwortlichen Stelle</strong></p>
                <p>
                    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                </p>
                <p>
                    HELLO CHARGE<br />
                    Asiatische Küche (HALAL)<br />
                    Hello Charge Restaurant GmbH<br />
                    Huttenstraße 68<br />
                    10553 Berlin
                </p>
                <p>
                    Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.).
                </p>
            </section>

            <section className="datenschutz-section">
                <h2>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h2>
                <p>
                    Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung möglich.
                    Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine
                    formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung
                    bleibt vom Widerruf unberührt.
                </p>
            </section>

            <section className="datenschutz-section">
                <h2>Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</h2>
                <p>
                    Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein Beschwerderecht bei der
                    zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher Fragen ist der
                    Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet.
                </p>
                <p>
                    Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten finden Sie hier:<br />
                    <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank" rel="noopener noreferrer">
                        www.bfdi.bund.de
                    </a>
                </p>
            </section>

            <section className="datenschutz-section">
                <h2>Recht auf Datenübertragbarkeit</h2>
                <p>
                    Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
                    automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in einem
                    maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
                    verlangen, erfolgt dies nur, soweit es technisch machbar ist.
                </p>
            </section>

            <section className="datenschutz-section">
                <h2>Recht auf Auskunft, Berichtigung, Sperrung, Löschung</h2>
                <p>
                    Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf unentgeltliche Auskunft
                    über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger sowie den Zweck der
                    Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu
                    weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über die im Impressum
                    aufgeführten Kontaktmöglichkeiten an uns wenden.
                </p>
            </section>

            <section className="datenschutz-section">
                <h2>SSL- bzw. TLS-Verschlüsselung</h2>
                <p>
                    Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte nutzt unsere Website eine
                    SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an der „https://“-Adresszeile Ihres
                    Browsers und am Schloss-Symbol in der Browserzeile.
                </p>
            </section>

            <section className="datenschutz-section">
                <h2>Datenübermittlung bei Vertragsschluss für Warenkauf und Warenversand</h2>
                <p>
                    Personenbezogene Daten werden nur an Dritte übermittelt, sofern dies im Rahmen der Vertragsabwicklung notwendig
                    ist. Dritte können z.B. Zahlungsdienstleister oder Logistikunternehmen sein. Eine weitergehende Übermittlung
                    findet nur statt, wenn Sie ausdrücklich zugestimmt haben.
                </p>
                <p>
                    Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO.
                </p>
            </section>

            <section className="datenschutz-section">
                <h2>Cookies</h2>
                <p>
                    Unsere Website verwendet Cookies. Diese kleinen Textdateien speichert Ihr Webbrowser auf Ihrem Endgerät.
                    Cookies machen unser Angebot nutzerfreundlicher, effektiver und sicherer.
                </p>
                <p>
                    Einige Cookies sind “Session-Cookies” und werden automatisch gelöscht. Andere bleiben gespeichert, bis Sie
                    diese löschen. Moderne Browser ermöglichen es, das Setzen von Cookies zu überwachen oder zu blockieren.
                </p>
                <p>
                    Das Setzen technisch notwendiger Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Sofern andere
                    Cookies gesetzt werden (z.B. Analysefunktionen), werden diese separat behandelt.
                </p>
            </section>

            <p className="datenschutz-source">
                Quelle: Datenschutz-Konfigurator von <a href="https://www.mein-datenschutzbeauftragter.de/" target="_blank" rel="noopener noreferrer">mein-datenschutzbeauftragter.de</a>
            </p>
        </div>
    );
};

export default Datenschutz;
